import { CommissionRuleMethod, ICommissionRule, ISale } from 'gen/ApiClient';
import { calculateCommissionX } from './calculateCommissionX';

export const calculateCommission = (sale: ISale, rule: ICommissionRule): number => {
	return calculateCommissionX(sale.priceExVat, sale.priceDevicesExVat, rule.method as CommissionRuleMethod, rule.percentage);
};
